<template>
  <div>
    <h3>Pre-Internship Petition (PIP)</h3>
    <div>
      <p>Use this form to:</p>
      <ul>
        <li>Request a new site to become affiliated with ASU (required for any opportunities found outside of this database).</li>
        <li>Request approval to intern at your current place of employment (must be related to your current major).</li>
        <li><a href="https://docs.google.com/presentation/d/1W2FEnmphkqIVhBJoFSRiayNWswuJTPapX0F5l3oTMYM/edit?slide=id.g1d9386fa236_5_8707#slide=id.g1d9386fa236_5_8707" target="_blank">Click here</a> for step-by-step instructions.</li>
      </ul>
      
    </div>
    <b-button v-b-modal="modalId" variant="primary flex-float-right" class="mt-sm-2" @click="show=!show">{{modalButtonLabel}}</b-button>
    <additional-material-modal 
      :modalId="modalId" 
      :show="show" 
      :title="modalButtonLabel" 
      :additionalMaterialType="pipForm"
      :studentOpportunity="studentOpportunityData"
      :userId="userId"
      @hideModal="hideModal" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import opportunityApi from "../../api/placements/opportunities.js";
import additionalMaterialModal from "../placements/additional-material-modal";

export default {
  data() {
    return {
      pipForm: {},
      modalId: "",
      show: false,
      studentOpportunityData: {
        studentOpportunityId: 0,
        //jobTitle: this.studentOpportunity.jobTitle,
        //otherAddress: this.studentOpportunity.otherAddress,
        //isPaid: this.studentOpportunity.isPaid,
        //isCurrentEmployee: this.studentOpportunity.isCurrentEmployee,
        goals: [],
        supervisors: [],
        //termStart: this.studentOpportunity.opportunity.term.termStart,
        studentOpportunityAdditionalMaterials: [],
        asuriteId: this.userId,
        opportunity: {
          opportunityId: 0,
          termId: 0,
        },
      },
    };
  },

  components: {
    additionalMaterialModal,
  },

  computed: {
    ...mapState({
      userId: (state) => state.auth.user.userId,
    }),
    modalButtonLabel: function() {
      if (this.pipForm.actionLabel) {
        return this.pipForm.actionLabel;
      }
      return this.pipForm.name;
    },
  },

  methods: {
    hideModal: function(item) {
      if (item.id == this.modalId) {
        this.show = false;
      }
    },
  },

  created() {
    var that = this;
    opportunityApi.getAdditionalMaterial("PIP Form").then((result) => {
      that.pipForm = result.data;
      that.modalId = "generate-modal" + this.pipForm.additionalMaterialTypeId;
    });
  },
};
</script>

<style scoped>
</style>
